import { makeStyles } from '@barracuda-internal/bds-core'

export default makeStyles(theme => ({
  root: {
    alignContent: 'center',
    marginTop: theme.spacing(2)
  }
}))
